// based on rc-tree 2.1.3
import Tree from './src';

export default Tree;
